var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5893 2.74408C10.9147 3.06951 10.9147 3.59715 10.5893 3.92259L5.34518 9.16667L16.6667 9.16667C17.1269 9.16667 17.5 9.53976 17.5 10C17.5 10.4602 17.1269 10.8333 16.6667 10.8333L5.34518 10.8333L10.5893 16.0774C10.9147 16.4028 10.9147 16.9305 10.5893 17.2559C10.2638 17.5814 9.73618 17.5814 9.41074 17.2559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73618 2.74408 9.41074L9.41074 2.74408C9.73618 2.41864 10.2638 2.41864 10.5893 2.74408Z",
    fill: "#131517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackward);
export default __webpack_public_path__ + "static/media/icon_backward.e8ad0bddca982855f5178f89f4a237b9.svg";
export { ForwardRef as ReactComponent };